
import { computed, defineComponent, onMounted, ref, toRef, watch } from "vue";
import {
  DroppableComponent,
  ISectionRow,
} from "../components/dynamicValidation";
import { FormBuilderService } from "@/services/FormBuilder.service";

import DrawComponent from "../components/DrawComponent.vue";
import { useRoute } from "vue-router";
import { FormApi } from "@/services/api/Form.service";
import { SiteApi } from "@/services/api/Site.service";
export interface SelectedDropElement {
  type: DroppableComponent;
  parentId: string;
}
export default defineComponent({
  name: "mobile-preview-modal",
  emits: ["update-data"],
  props: {
    data: {
      type: Array as () => Array<ISectionRow>,
      required: true,
    },
  },
  components: {
    DrawComponent,
  },
  setup(props, { emit }) {
    const route = useRoute();
    const formStructureVal = toRef(props, "data");
    const formStructure = ref<Array<ISectionRow>>([]);
    const sites = ref<any>({});
    const forms = ref<any>({});
    const selectedForm = ref<string>("");
    const selectedSite = ref<string>("");
    const sectionId = computed(() => {
      return route.params.id as string;
    });
    const MAX_BLOCKS = 60;
    const spanInColumn = computed(() => {
      return formStructure?.value?.map((row) =>
        row?.columns?.reduce((pre, curr) => +curr?.colSpan + +pre, 0)
      );
    });
    onMounted(async () => {
      try {
        const responses = await Promise.all([
          SiteApi.getInstance().getSiteList({
            size: Number.MAX_SAFE_INTEGER,
            status: "ACTIVE",
          }),
          FormApi.getInstance().getFormList({
            size: Number.MAX_SAFE_INTEGER,
            status: "ACTIVE",
          }),
        ]);
        sites.value = responses[0].content;
        sites.value.sort((a, b) => (a.name > b.name ? 1 : -1));
        forms.value = responses[1].content;
        forms.value.sort((a, b) => (a.name > b.name ? 1 : -1));
        initTable();
      } catch (e) {
        console.log(e);
      }
    });
    const applyChanges = () => {
      emit("update-data", {
        device: "mobile",
        form: selectedForm.value,
        site: selectedSite.value,
      });
    };

    const clearData = () => {
      selectedForm.value = "";
      selectedSite.value = "";
    };

    const initTable = async () => {
      try {
        formStructure.value = FormBuilderService.getInstance().initTable(
          formStructureVal.value,
          sectionId
        );
      } catch (e) {
        console.log(e);
      }
    };
    watch(
      formStructureVal,
      (newVal) => {
        formStructure.value = FormBuilderService.getInstance().initTable(
          newVal,
          sectionId
        );
      },
      { deep: true }
    );
    return {
      formStructure,
      sites,
      forms,
      selectedForm,
      selectedSite,
      applyChanges,
      clearData,
      spanInColumn,
      MAX_BLOCKS,
    };
  },
});
